import { defineStore } from "pinia";
import Services from '@/services/residentialCardServices'
import { mapResidentialCard } from '@/helpers/mapFuncs'

export const useResidentialCardStore = defineStore("residentialCard", {

state:()=>({
    residentialCard: {},
    residentialCards: [],
}),
getters : {
    getResidentialCard() {
        return mapResidentialCard(this.residentialCard)
    },
    getResidentialCards() {
        return this.residentialCards.map(mapResidentialCard)
    }
},
actions : {
    /** Start Sets */
    setResidentialCard(residentialCard) {
        this.residentialCard = residentialCard
    },
    setResidentialCards(residentialCards) {
        this.residentialCards = residentialCards
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setResidentialCard(response.data.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setResidentialCard(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setResidentialCards(response.data.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.residentialCards.push(response.data.data)
            return mapResidentialCard(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.residentialCards[this.residentialCards.findIndex((x)=>x.id == id)] = response.data.data
            return mapResidentialCard(response.data.data)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.residentialCards = this.residentialCards.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});